<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/NZZfyg/tc-custom/9781453211465.jpg?1733083252914" alt="This image is the cover for the book Night of the Fox, The Dougal Munro and Jack Carter Novels"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Night of the Fox, The Dougal Munro and Jack Carter Novels
      </h1>
      <p class="bookDescription body article font2">
        <b>The <i>New York Times</i>–bestselling author’s “most tingling thriller since <i>The Eagle Has Landed</i>”: An agent poses as a Nazi for a mission on the verge of D-Day (<i>Publishers Weekly</i>). </b><br/>  <br/> In May of 1944, shipwrecked American Colonel Hugh Kelso washes up on the shore of Nazi-occupied Jersey—with a valuable secret. As one of the few men with knowledge of the impending invasion of Normandy, Kelso must be rescued at all costs.<br/>  <br/> Enter Harry Martineau, a covert British operative charged with the dangerous mission of impersonating a Nazi officer to infiltrate Jersey and retrieve—or silence—Colonel Kelso. It is not only their lives that hang in the balance . . .<br/>  <br/> A riveting World War II thriller, <i>Night of the Fox</i> is “an exceptional tale” from the multimillion-selling author of the Liam Devlin and Sean Dillon series, a master of edge-of-your-seat espionage adventure (<i>Library Journal</i>). It was adapted into a TV film starring George Peppard, John Mills, and Michael York.<br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jack Higgins
      </h2>
      
      <p class="authorDescription body article"><P> Jack Higgins is the <I>New York Times</I> bestselling author of more than sixty thrillers that have sold over 250 million copies worldwide, including <I>The Eagle Has Landed</I> and <I>The Wolf at the Door</I>. Before beginning his writing career, Higgins served in the British Army along the East German border. He lives in the Channel Islands. </P><P> &#160; </P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?206a0658